/* eslint-disable */
import React, { useState, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useStorage } from '../../../hooks';
import {
  Topbar,
  Navbar,
  DashboardFooter,
  Breadcrumb,
} from '../../../components';
import { Users } from '../Users/Users';
import { Permissions } from '../../../pages/AccessControl/Permissions/Permissions';
import { Container, Content } from '../../../styles/lib/grid';
import {
  TabBadge,
  TabSelector,
  TabsNavigation,
  TabsSelector,
} from '../../../styles/lib/tabs';
import { TitleContent } from '../../../styles/lib/typography';
import { ActivityHistory } from '../ActivityHistory';
import { NewUsers } from '../Users/NewUsers';

const TABS = {
  USERS: 'users',
  NEW_USERS: 'new-users',
  PERMISSIONS: 'permissions',
  ACTIVITY_HISTORY: 'activity-history',
} as const;

const PATHS = {
  PANEL: '/painel',
  ACCESS_CONTROL: '/gestao-de-equipe/equipe',
  USERS: '/gestao-de-equipe/equipe',
  PERMISSIONS: '/controle-de-acesso/perfis',
  NEW_USERS: '/controle-de-acesso/novos-usuarios',
  ACTIVITY_HISTORY: '/controle-de-acesso/historico-de-atividades',
} as const;

type TabType = keyof typeof TABS;

export const AccessTabNavigation: React.FC = () => {
  const { getItemOnStorage } = useStorage();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const activeTab: TabType = useMemo(() => {
    if (pathname.includes('novos-usuarios')) return 'NEW_USERS';
    if (pathname.includes('equipe')) return 'USERS';
    if (pathname.includes('perfis')) return 'PERMISSIONS';
    if (pathname.includes('historico-de-atividades')) return 'ACTIVITY_HISTORY';
    return 'NEW_USERS';
  }, [pathname]);

  const handleTabClick = (tab: TabType) => {
    navigate(PATHS[tab]);
  };

  const user = useMemo(
    () => JSON.parse(getItemOnStorage('currentUser') || '{}'),
    [getItemOnStorage],
  );
  const [totalEmAnalise, setTotalEmAnalise] = useState<string | null>(null);

  const pageTitle = useMemo(() => {
    switch (activeTab) {
      case 'USERS':
        return 'Equipe';
      case 'NEW_USERS':
        return 'Novos usuários';
      case 'PERMISSIONS':
        return 'Gestão de Perfis';
      case 'ACTIVITY_HISTORY':
        return 'Histórico de Atividades';
      default:
        return '';
    }
  }, [activeTab]);

  const breadcrumbPaths = useMemo(
    () => [
      { title: 'Meu Painel', link: PATHS.PANEL },
      { title: 'Gestão de Equipe', link: PATHS.ACCESS_CONTROL },
      { title: pageTitle, link: PATHS[activeTab] },
    ],
    [activeTab, pageTitle],
  );

  return (
    <Container>
      <Topbar />
      <Navbar />
      <Content className="modify-content">
        <Breadcrumb paths={breadcrumbPaths} />
        <TitleContent style={{ marginBottom: '3%' }}>{pageTitle}</TitleContent>

        <TabsNavigation>
          <TabsSelector className="secondary">
            {/* <TabSelector
              className={activeTab === 'NEW_USERS' ? 'active' : ''}
              onClick={() => handleTabClick('NEW_USERS')}
            >
              Novos usuários
              <TabBadge className={activeTab === 'NEW_USERS' ? '' : 'inactive'}>
                {totalEmAnalise || '-'}
              </TabBadge>
            </TabSelector> */}
            <TabSelector
              className={activeTab === 'USERS' ? 'active' : ''}
              onClick={() => handleTabClick('USERS')}
            >
              Equipe
            </TabSelector>
            {/* <TabSelector
              className={activeTab === 'ACTIVITY_HISTORY' ? 'active' : ''}
              onClick={() => handleTabClick('ACTIVITY_HISTORY')}
            >
              Histórico de Atividades
            </TabSelector>
            {user?.perfil === 'administrador' && (
              <TabSelector
                className={activeTab === 'PERMISSIONS' ? 'active' : ''}
                onClick={() => handleTabClick('PERMISSIONS')}
              >
                Perfis
              </TabSelector>
            )} */}
          </TabsSelector>
        </TabsNavigation>
      </Content>

      {activeTab === 'NEW_USERS' && (
        <NewUsers setTotalEmAnalise={setTotalEmAnalise} />
      )}
      {activeTab === 'USERS' && <Users />}
      {activeTab === 'PERMISSIONS' && <Permissions />}
      {activeTab === 'ACTIVITY_HISTORY' && <ActivityHistory />}

      <DashboardFooter />
    </Container>
  );
};
